export default "__VITE_ASSET__BG_Eubl1__"